<template>
    <div class="card">
        <b-container fluid>
            <b-row v-if="hasMedecinControleRole || hasPraticienRole || hasAdminRole || hasAssistante" class="mt-3 mb-4">
                <b-col sm="4" md="4" lg="4" xm="12">
                    <b-button class="border-0" variant="outline-success" @click="viewTrajetPatient">
                        <img src="/img/icons/icone_navbar/parcours_soins.png" class="p-0" alt="Parcours de soins" width="20">
                                {{ $t('message.Trajet') }}
                            </b-button>
                        </b-col>
                <b-col sm="4" md="4" lg="4" xm="12">
                    <router-link
                        :to="{
                        name: 'lists-timelines',
                        params: { file: this.$route.params.file},
                        }"
                        v-if="
                        can ||
                            hasPraticienRole ||
                            hasMedecinControleRole ||
                            hasAssistante">
                        <b-button variant="outline-success" class="border-0">
                            <i class="fas fa-list" width="30"></i>
                            {{ $t("message.Listsligne") }}
                        </b-button>
                    </router-link>
                    
                </b-col>
                <b-col sm="4" md="4" lg="4" xm="12">
                    <router-link
                        :to="{
                        name: 'add-trajet-patient',
                        params: { file: this.$route.params.file, patient_id: file.patient_id  },
                        }">
                    <b-button variant="outline-success" v-if=" can || hasPraticienRole || hasMedecinControleRole || hasAssistante" class="border-0" @click="AddLigneDeTemps">
                        <i class="fas fa-plus" width="30"></i>
                        {{ $t("message.Addligne") }}
                    </b-button>
                    </router-link>
                </b-col>
                
            </b-row>
            <b-row v-if="!mobileView">
                <b-col col sm="12">
                    <b-card no-body>
                        <b-tabs card content-class="mt-3" fill active-nav-item-class="font-weight-bold text-uppercase text-success">
                            <PersonnalData :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasSouscripteurRole="hasSouscripteurRole" :hasPatientRole="hasPatientRole" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                            <Allergie :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                            <Antecedent :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                            <Consultation :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                            <Traitement :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                            <Prescription :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                            <Resultat :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                            <Hospitalisation :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                            <MedicalAdvice :hasAdminRole="hasAdminRole" :hasGestionnaireRole="hasGestionnaireRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                            <FichierExterne :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                            <CompteRendu :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
     
        <b-row v-if="mobileView">
        <div class="medicalUl w-100">
           <div class="mobileDropdown" v-on:click="dropDown, dropHidden=true">
                    <h5 class="d-inline text-success m-3 font-weight-bold"> Dossier Médical</h5>
                        <div class="mobileDropbtn d-inline p-0">
                        <p class="fas text-success d-inline mr-3" @click="dropDown, dropHidden=true">&#xf106;</p>          
                        </div>
                        <div class="medicalDropdown-content" id="myDropdown"  v-if="dropHidden">
                            <div class="p-2" @click="isInfo = true, isAllergie=false, isAntecedent=false, isConsultation=false, isTraitement=false, isPrescription=false, isResult = false, isHospitalisation = false, isAvis = false, isFichier = false, isCompterendu = false, dropHidden=false">
                                <p>Données Personnelles</p>
                            </div>
                            <div class="p-2" @click="isInfo = false, isAllergie=true, isAntecedent=false, isConsultation=false, isTraitement=false, isPrescription=false, isResult = false, isHospitalisation = false, isAvis = false, isFichier = false, isCompterendu = false, dropHidden=false">
                                <p>Allergie</p>
                            </div>
                            <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=true, isConsultation=false, isTraitement=false, isPrescription=false, isResult = false, isHospitalisation = false, isAvis = false, isFichier = false, isCompterendu = false, dropHidden=false">
                                <p>Antécédents</p>
                            </div>
                            <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isConsultation=true, isTraitement=false, isPrescription=false, isResult = false, isHospitalisation = false, isAvis = false, isFichier = false, isCompterendu = false, dropHidden=false">
                                <p>Consultations</p>
                            </div>
                            <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isConsultation=false, isTraitement=true, isPrescription=false, isResult = false, isHospitalisation = false, isAvis = false, isFichier = false, isCompterendu = false, dropHidden=false">
                                <p>Traitement actuel</p>
                            </div>
                            <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isConsultation=false, isTraitement=false, isPrescription=true, isResult = false, isHospitalisation = false, isAvis = false, isFichier = false, isCompterendu = false, dropHidden=false">
                                <p>Prescriptions</p>
                            </div>
                            <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isConsultation=false, isTraitement=false, isPrescription=false, isResult = true, isHospitalisation = false, isAvis = false, isFichier = false, isCompterendu = false, dropHidden=false">
                                <p>Résultats</p>
                            </div>
                            <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isConsultation=false, isTraitement=false, isPrescription=false, isResult = false, isHospitalisation = true, isAvis = false, isFichier = false, isCompterendu = false, dropHidden=false">
                                <p>Hospitalisations</p>
                            </div>
                            <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isConsultation=false, isTraitement=false, isPrescription=false, isResult = false, isHospitalisation = false, isAvis = true, isFichier = false, isCompterendu = false, dropHidden=false">
                                <p>Avis médiceaux</p>
                            </div>
                            <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isConsultation=false, isTraitement=false, isPrescription=false, isResult = false, isHospitalisation = false, isAvis = false, isFichier = true, isCompterendu = false, dropHidden=false">
                                <p>Fichiers Médicaux</p>
                            </div>
                            <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isConsultation=false, isTraitement=false, isPrescription=false, isResult = false, isHospitalisation = false, isAvis = false, isFichier = false, isCompterendu = true, dropHidden=false">
                                <p>Compte Rendu</p>
                            </div>
                        </div>
                    </div>    
               </div>
        <div class="table-responsive">
            <div class="row">
                <b-tabs content-class="mt-3" fill active-nav-item-class="font-weight-bold text-uppercase text-success">
                    <PersonnalData v-if="isInfo" :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasSouscripteurRole="hasSouscripteurRole" :hasPatientRole="hasPatientRole" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>  
                    <Allergie v-if="isAllergie" :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                    <Antecedent v-if="isAntecedent" :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                    <Consultation v-if="isConsultation" :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                    <Traitement v-if="isTraitement" :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                    <Prescription v-if="isPrescription" :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                    <Resultat v-if="isResult" :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                    <Hospitalisation v-if="isHospitalisation" :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                    <MedicalAdvice v-if="can && isAvis" :hasAdminRole="hasAdminRole" :hasGestionnaireRole="hasGestionnaireRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                    <FichierExterne v-if="isFichier" :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>
                    <CompteRendu v-if="isCompterendu" :hasAdminRole="hasAdminRole" :hasMedecinControleRole="hasMedecinControleRole" :hasAssistante="hasAssistante" :hasPraticienRole="hasPraticienRole" :file_id="this.$route.params.file"/>      
                </b-tabs>
          </div>  
                        
        </div>                   
     </b-row> 
    </b-container>
    
    </div>
    </template>
    
    <script>
    import { mapGetters } from 'vuex';
    import _ from 'lodash';
    import $ from 'jquery';
    import SlimSelect from "slim-select";
    import moment from "moment";
    import Vue from 'vue';
    import axios from 'axios';
    import Swal from 'sweetalert2';
    import AppConfig from '../../constants/AppConfig';
    
    import PersonnalData from './PersonnalData.vue';
    import Allergie from './Allergie.vue';
    import Antecedent from './Antecedent.vue';
    import Consultation from './Consultation.vue';
    import Traitement from './Traitement.vue';
    import Prescription from './Prescription.vue';
    import Resultat from './Resultat.vue';
    import Hospitalisation from './Hospitalisation.vue';
    import MedicalAdvice from './MedicalAdvice.vue'
    import FichierExterne from './FichierExterne.vue'
    import CompteRendu from './CompteRendu.vue'
    
    export default {
        name: "MedicalFile",
        components:{
        PersonnalData,
        Allergie,
        Antecedent,
        Consultation,
        Traitement,
        Prescription,
        Resultat,
        Hospitalisation,
        MedicalAdvice,
        FichierExterne,
        CompteRendu
    },
    
        computed: {
            ...mapGetters(["file",
                'hasAdminRole',
                'hasGestionnaireRole',
                'hasPraticienRole',
                "controlDoctors",            
                'hasMedecinControleRole',
                'hasSouscripteurRole',
                'hasPatientRole',
                "medicalAdvices",
                'hasAssistante',
                "affiliation"
            ]),
    
            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
            },
        },

        data() {
            return {
                mobileView: true,
                isInfo:true,
                isAllergie:false,
                isAntecedent:false,
                isConsultation:false,
                isTraitement:false,
                isPrescription:false,
                isResult:false,
                dropHidden:true,
                isHospitalisation:false,
                isAvis:false,
                isFichier:false,
                isCompterendu:false,
                option:{
                    penColor:"rgb(0, 0, 0)",
                    backgroundColor:"rgb(255,255,255)"
                },
                  form:{
                },
                file_id: this.$route.params.file            
            }
        },
    
        watch: {
            //
        },
    
        methods: {
        handleView() {
            this.mobileView = window.innerWidth <= 990;
            localStorage.setItem('reload', 0);
            localStorage.setItem("dossier_medical_slug", this.$route.params.file);
        }, 
        dropDown() {
              var y = document.getElementById("myDIV")
              var x = document.getElementById("myDropdown");
              $('.mobileUl').click(function(){
               $('.mobileDropbtn').toggleClass("rotate");
             });
                  if (x.style.display === "none") {
                    x.style.display = "block";       
                  } else {
                    x.style.display = "none";
            }
          },
            viewTrajetPatient(params){
                // console.log(this.file.slug);
                this.$router.push(  (this.$router.resolve({ name: 'trajet-patient',  params: { file: this.$route.params.file } })).href +  '#generale');
            },  
    
            AddLigneDeTemps(params){
                 this.$router.push(  (this.$router.resolve({ name: 'add-trajet-patient',  params: { file: this.$route.params.file } })).href +  '#generale');
            },
    
            getMedicalFile() {
                let args = {
                    file: this.file_id
                };
    
                this.$store.dispatch("getMedicalFile", {
                    args
                });
            },

        },
        validations() {
            return {
                form: {
    
                    responsable:{
    
                    },
                }
            }
        },
        created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
          },
        mounted() {
            this.getMedicalFile();
        }
    }
    </script>
    
    <style lang="scss" scoped></style>
    